import { Divider } from '@mui/material';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { ADD_SHIPMENTS_QUERY_PARAMS } from 'pages/Shipments/params';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchWatchedShipments, WatchlistQueryKeys } from 'services/clients/watchList';
import { Filters } from './Filters';
import { Search } from './Search';
import { Table } from './Table';

export const RecentlyAdded: React.FC = () => {
  const { searchParams } = useCustomSearchParams(ADD_SHIPMENTS_QUERY_PARAMS);

  const shipmentsQuery = useQuery(
    [WatchlistQueryKeys.WatchedShipments, searchParams],
    ({ signal }) => fetchWatchedShipments(signal, searchParams)
  );

  return (
    <div className="space-y-4">
      <h2 className="font-medium">Recently added shipments</h2>
      <Divider />
      <div className="flex justify-between items-center space-x-4">
        <Search />
        <Filters />
      </div>
      <Table shipmentsQuery={shipmentsQuery} />
    </div>
  );
};
RecentlyAdded.displayName = 'Shipments.AddContainers.RecentlyAdded';
